/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { FindAll2Params, SavePayload, SpendPolicyDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiSpendPolicyController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-spend-policy-controller
   * @name Save
   * @request POST:/api/v1/spend-policy/request
   */
  save = (data: SavePayload, params: RequestParams = {}) =>
    this.http.request<SpendPolicyDto, any>({
      path: `/v1/spend-policy/request`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static savePath = '/v1/spend-policy/request'
  static saveMethod = 'POST'
  /**
   * No description
   *
   * @tags api-spend-policy-controller
   * @name FindAll2
   * @request GET:/api/v1/spend-policy
   */
  findAll = (query: FindAll2Params, params: RequestParams = {}) =>
    this.http.request<SpendPolicyDto[], any>({
      path: `/v1/spend-policy`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findAllPath = '/v1/spend-policy'
  static findAllMethod = 'GET'
  /**
   * No description
   *
   * @tags api-spend-policy-controller
   * @name FindById3
   * @request GET:/api/v1/spend-policy/{id}
   */
  findById = (id: string, params: RequestParams = {}) =>
    this.http.request<SpendPolicyDto, any>({
      path: `/v1/spend-policy/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findByIdPath = '/v1/spend-policy/${id}'
  static findByIdMethod = 'GET'
}
